module.exports = __webpack_public_path__ + "static/media/bill_two.52701b19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-flight/landing/bill_two.png
// module id = 1410
// module chunks = 0